// extracted by css-extract-rspack-plugin
export default {"ListLoadingHeader":"ListLoading-module__ListLoadingHeader__c5VrTp1"};